import styled from "styled-components";
import { InviteIcon } from "@assets";
import {
	Button as AntButton,
	Divider as AntDivider,
} from "antd";
import { BURMESE_LANGUAGE_CODE_LK } from "@constants";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 0 16px 0;
`;

export const ChainIconContainer = styled.div`
	margin: 119px 0 0 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 84px;
	height: 84px;
`;
export const ChainIcon = styled(InviteIcon)``;
export const InviteLinkTitle = styled.p`
	margin: 16px 0 0 0;
	color: #808080;
	text-align: center;
	font-family: Plus Jakarta Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

export const CreateLinkButton = styled(AntButton)`
	padding: 0;
	margin: 20px 0 0 0;
	width: ${props => props.language === BURMESE_LANGUAGE_CODE_LK ? '110px' : '88px'}  ;
	height: 32px;
	border-radius: 8px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;

	color: #f9f9f9 !important;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	background: #212224 !important;

	:hover {
		background: #212224 !important;
		color: #f9f9f9 !important;
	}

	/* svg {
		width: 40px !important;
		height: 40px !important;
	} */
`;

export const TermsAndConditionsContainer = styled.div`
	border-radius: 12px;
	padding: 16px;
	margin: 24px 0 0 0;
`;

export const InviteLinkTerm = styled.p`
	text-align: center;
	margin: 0px;
	padding: 0px;
	color: #f9f9f9;
	font-size: 14px;
	font-style: normal;
	line-height: 24px;
	font-weight: 500;
	line-height: normal;
`;

export const DividerWrapper = styled.div`
	width: 36px;
	margin: 0 auto;
`;

export const Divider = styled(AntDivider)`
	margin: 15px 0;
	border-color: #d28a28;
`;

export const InviteLinkTerms = styled.span`
	font-size: 14px;
	margin: 0px;
	padding: 0px;
	color: #9f9fa2;
	font-family: Plus Jakarta Sans;
	font-size: 12px;
	font-style: normal;
	font-weight: 300;
	line-height: 24px;
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
	color: #f9f9f9;
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 25px;
`;

export const CopyLink = styled.a`
	display: block;
	/* margin-bottom: px; */
	text-decoration: underline;
	color: #ffb829;
	text-align: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;

	:hover {
		color: #ffb829 !important;
		text-decoration: underline;
	}
`;

// export const Modal = styled(AntModal)`
	/* .ant-modal-title {
		text-align: center;
		color: #f9f9f9 !important;
		font-size: 18px;
		font-weight: bold;
	} */
	/* .ant-modal-content {
		background: linear-gradient(20deg, #0e1017 0%, #212224 100%);
	} */

	/* .ant-modal-footer {
		.ant-btn-primary {
			width: calc(100% - 24px) !important;
			height: 52px;
			border-radius: 37px;
			border-radius: 8px !important;
			background: linear-gradient(90deg, #ffb829 0%, #914706 100%);
			margin: 0 !important;
		}
		.ant-btn-default {
			background: #212224 !important;
			border-radius: 8px !important;
			color: #f9f9f9 !important;
			font-size: 16px;
			font-weight: 600;
			line-height: 20px;
		}
	} */
// `;
